import { render, staticRenderFns } from "./PlanStructuringPhase.vue?vue&type=template&id=0c21d711&"
import script from "./PlanStructuringPhase.vue?vue&type=script&lang=js&"
export * from "./PlanStructuringPhase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports